
import './Buttons.css';


const EllaButton = ({ onSetCurrentPage }) => {


    return (
        <button 
        className="ellas-corner ellas-corner-item"
        onClick={() => {

            setTimeout(() => {
                window.location.href = '/ella-bella';
            }
            , 500);
        }}
        >
            <span className="ellas-corner-bg">
                <span className="ellas-corner-bg-layers">
                <span className="ellas-corner-bg-layer ellas-corner-bg-layer-1 -purple"></span>
                <span className="ellas-corner-bg-layer ellas-corner-bg-layer-2 -turquoise"></span>
                <span className="ellas-corner-bg-layer ellas-corner-bg-layer-3 -yellow"></span>
                </span>
            </span>
            <span className="ellas-corner-inner">
                <span className="ellas-corner-inner-static ella">Ella's Corner</span>
                <span className="ellas-corner-inner-hover ella">Ella's Corner</span>
            </span>
        </button>

    )
}

export default EllaButton;